import React, { useRef, useCallback, useEffect } from 'react';

import { CloseIcon } from '../../../utils/icons';

function ModalMain({ title, children, onClose, className = '' }) {
  const modalRef = useRef(null);

  // const modalClassName = useMemo(() => {
  //   return `portal-modal modal ${className}`;
  // }, [children?.props?.className, className]);


  const modalClassName = `portal-modal modal ${className || children?.props?.className || ''}`;
  

  const closeWithTransition = useCallback(() => {
    const el = modalRef.current;
    if (!el) return;
    const handleTransitionEnd = (e) => {

      if (e.target !== el) return;
      el.removeEventListener('transitionend', handleTransitionEnd);
      onClose();
    };
    el.addEventListener('transitionend', handleTransitionEnd);
    el.setAttribute('aria-hidden', 'true');
  }, [onClose]);

  useEffect(() => {
    const close = (e) => {
      if(e.key === 'Escape'){
        onClose();
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  },[])

  return (
    <div ref={modalRef} className={`${modalClassName}` } aria-hidden="false" >
      <div className="modal-backdrop" onClick={closeWithTransition}></div>
      <div className="modal__dialog">
        <header className="modal__header">
          <h3 className="modal__title heading heading--h3">
            {children?.props?.title}
          </h3>
          <button
            type="button"
            className="modal__close link"
            onClick={closeWithTransition}
            aria-label="Close modal"
            title="Close"
          >
            <CloseIcon />
          </button>
        </header>
        <div className="modal__content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default ModalMain;
